import browser from '@openclassrooms/utils/browser';

const css = {};

// eslint-disable-next-line func-names
css.injectCss = function (rules, doc = browser.document) {
  const style = doc.createElement('style');
  style.appendChild(doc.createTextNode(rules));
  doc.getElementsByTagName('head')[0].appendChild(style);
};

// eslint-disable-next-line func-names
css.loadStylesheet = function (stylesheetUrl, doc = browser.document) {
  const style = doc.createElement('link');
  style.href = stylesheetUrl;
  style.rel = 'stylesheet';
  style.type = 'text/css';

  return new Promise((resolve) => {
    doc.getElementsByTagName('head')[0].appendChild(style);
    style.addEventListener('load', resolve);
  });
};

export default css;
